import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import portfolioData from '../data/portfolio';
import SocialLinks from '../components/SocialLinks';
import LanguageSwitch from '../components/LanguageSwitch';

function About({ language, onLanguageChange }) {
  const data = portfolioData[language] || portfolioData.en;
  const profileParagraphs = data.profile || [];

  return (
    <div className="About">
      <Link to="/">← {language === 'en' ? 'Home' : 'Início'}</Link>
      <article className="App-profile">
        <header className="App-profile-header">
          <h1>{language === 'en' ? 'About me' : 'Sobre mim'}</h1>
          <p className="App-profile-role">{data.role}</p>
          <p className="App-profile-location">{data.location}</p>
          <LanguageSwitch language={language} onChange={onLanguageChange} />
        </header>

        <section className="App-section">
          {profileParagraphs.map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </section>
      </article>

      <SocialLinks title={language === 'en' ? 'Connect' : 'Conecte-se'} />
    </div>
  );
}

About.propTypes = {
  language: PropTypes.oneOf(['en', 'pt-BR']).isRequired,
  onLanguageChange: PropTypes.func.isRequired,
};

export default About;
